// TrieNode class represents each node in the Trie
class TrieNode {
    children: Map<string, TrieNode>;
    isEndOfWord: boolean;

    constructor() {
        this.children = new Map();
        this.isEndOfWord = false;
    }
}

// Trie class with insert and search operations
export class Trie {
    root: TrieNode;

    constructor() {
        this.root = new TrieNode();
    }

    // Insert a word into the Trie
    insert(word: string) {
        let current = this.root;
        for (let char of word) {
            if (!current.children.has(char)) {
                current.children.set(char, new TrieNode());
            }
            current = current.children.get(char)!;
        }
        current.isEndOfWord = true;
    }

    // Search for words with a given prefix
    searchPrefix(prefix: string): string[] {
        let current = this.root;
        const result: string[] = [];
        for (let char of prefix) {
            if (!current.children.has(char)) {
                return result;
            }
            current = current.children.get(char)!;
        }
        this.collectWords(current, prefix, result);
        return result;
    }

    // Recursively collect all words from a given node
    private collectWords(node: TrieNode, prefix: string, result: string[]) {
        if (node.isEndOfWord) {
            result.push(prefix);
        }
        for (let [char, childNode] of node.children.entries()) {
            this.collectWords(childNode, prefix + char, result);
        }
    }
}
